const VerificationSteps = () => {
  // const router = useRouter();
  return (
    <>
       <div className="flex justify-start items-start gap-4 flex-col pb-2">
        <p className="text-sm">
          A confirmation message has been sent to your email.
        </p>
        <p>
          Verify your account by clicking the link. Please check spam if not
          found.
        </p>

        <p>After verifying, refresh the page for updates.</p>
      </div>
    </>
  );
};

export default VerificationSteps;
